import { render, staticRenderFns } from "./UnpairedDatasetElementView.vue?vue&type=template&id=7c92ebf8"
import script from "./UnpairedDatasetElementView.vue?vue&type=script&setup=true&lang=ts"
export * from "./UnpairedDatasetElementView.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports